<template>
    <div class="container">
        <el-form label-width="180px" label-position="right">
            <el-form-item label="部门名称:">
                {{departmentData.departmentName}}
            </el-form-item>
            <el-form-item label="转移前上级组织机构:">
                <el-input v-model="departmentData.lastInstitutionName"></el-input>
            </el-form-item>
            <el-form-item label="转移后上级组织机构:">
                <el-input v-model="nextInstitutionName" @focus="openInstitutionDialog"></el-input>
            </el-form-item>
        </el-form>
        <InstitutionDialog :visible="institutionDialogShow" :dialogTitle="dialogTitle" @close="closeInstitutionDialog"></InstitutionDialog>
    </div>
</template>

<script>
    import InstitutionDialog from '../../components/authority/institutionDialog'
    export default {
        name: "removeDepartment",
        components: {
            InstitutionDialog
        },
        props: {
        },
        data() {
            return {
                nextInstitutionName:'',
                departmentData: this.$route.query.departmentData ? this.$route.query.departmentData : '',
                institutionDialogShow:false,
                dialogTitle:''
            }
        },
        computed: {},
        created() {
        },
        methods: {
            openInstitutionDialog(){
                this.dialogTitle = '组织机构'
                this.institutionDialogShow = true
            },
            closeInstitutionDialog(){
                this.institutionDialogShow = false
            }
        }

    }
</script>

<style scoped>

</style>
